// import { isTestContentLocation } from "@/config"
import config from '@/config'
export const adobeAnalyticsDataUrl = `${config.API_URL}/api/v1/vendor/param?name=analytics`;
// export const analyticsUrl = isTestContentLocation ? 'https://assets.adobedtm.com/20117d61d4d3/4f58af6d7ced/launch-21f59086e6ea-staging.min.js' : 'https://assets.adobedtm.com/20117d61d4d3/4f58af6d7ced/launch-140e11a39393.min.js'
